<template>
  <div>
    <div class="tittle">主体详情</div>
    <div class="content">
      <el-form :model="subjectData" :inline="true" :rules="dataRules" ref="subjectData" class="ml20 mr20" label-position="right" label-width="270px">
        <toggle-form title="平台信息">
          <div class="item">
            <el-form-item label="TOBID：">
              <div class="w300">
                <div class="w300">{{subjectData.tobId ? '已绑定' : '未绑定'}}</div>
              </div>
            </el-form-item>
            <div></div>
            <el-form-item label="TOBID：" prop="tobId">
              <div class="w300">{{subjectData.tobId ? subjectData.tobId : '-'}}</div>
            </el-form-item>
            <el-form-item label="理菜宝名称：" prop="tobName" >
              <div class="w300">{{subjectData.tobName ? subjectData.tobName : '-'}}</div>
            </el-form-item>
            <div></div>
            <el-form-item label="TOGID：">
              <div class="w300">{{subjectData.togId ? '已绑定' : '未绑定'}}</div>
            </el-form-item>
            <div></div>
            <el-form-item label="TOGID：" prop="togId">
              <div class="w300">{{subjectData.togId ? subjectData.togId : '-'}}</div>
            </el-form-item>
            <el-form-item label="TOG环境名称：" prop="togSystemName">
              <div class="w300">{{subjectData.togSystemName ? subjectData.togSystemName : '-'}}</div>
            </el-form-item>
            <el-form-item label="TOG名称：" prop="togName">
              <div class="w300">{{subjectData.togName ? subjectData.togName : '-'}}</div>
            </el-form-item>
            <div></div>
            <!-- <el-form-item label="第三方平台类型：" prop="">
              <div class="w300">{{subjectData.tobId ? subjectData.tobId : '-'}}</div>
            </el-form-item>
            <el-form-item label="第三方平台ID：" prop="">
              <div class="w300">{{subjectData.tobId ? subjectData.tobId : '-'}}</div>
            </el-form-item> -->
            <!-- <el-form-item label="摄像头初始化：" prop="cameraInit">
              <div class="w300">{{subjectData.cameraInit ? subjectData.cameraInit : '-'}}</div>
            </el-form-item> -->
          </div>
        </toggle-form>
        <toggle-form title="基本信息">
          <div class="item">
            <el-form-item label="主体名称：" prop="buyerName">
              <div class="w300">{{subjectData.buyerName ? subjectData.buyerName : '-'}}</div>
            </el-form-item>
            <el-form-item label="所属行政区域：" prop="areaName">
              <div class="w300">{{subjectData.areaName ? subjectData.areaName : '-'}}</div>
            </el-form-item>
            <el-form-item label="启用禁用：" prop="available">
              <div class="w300">{{subjectData.available ? subjectData.available : '-'}}</div>
            </el-form-item>
            <el-form-item label="街道名称：" prop="streetAreaName">
              <div class="w300">{{subjectData.streetAreaName ? subjectData.streetAreaName : '-'}}</div>
            </el-form-item>
            <el-form-item label="同步TOB管理员账号及密码：" prop="isSyncTobAdminAccount">
              <div class="w300">{{subjectData.isSyncTobAdminAccount ? subjectData.isSyncTobAdminAccount : '-'}}</div>
            </el-form-item>
            <el-form-item label="管理员姓名：" prop="adminName">
              <div class="w300">{{subjectData.adminName ? subjectData.adminName : '-'}}</div>
            </el-form-item>
            <el-form-item label="管理员账号：" prop="adminAccount">
              <div class="w300">{{subjectData.adminAccount ? subjectData.adminAccount : '-'}}</div>
            </el-form-item>
            <el-form-item label="管理员密码：" prop="adminPassword">
              <div class="w300">{{subjectData.adminPassword ? '********' : '-'}}</div>
            </el-form-item>
            <el-form-item label="采集模式：" prop="acquisitionMode">
              <div class="w300">{{subjectData.acquisitionMode ? subjectData.acquisitionMode : '-'}}</div>
            </el-form-item>
            <el-form-item label="溯源模式：" prop="traceabilityMode">
              <div class="w300">{{subjectData.traceabilityMode ? subjectData.traceabilityMode : '-'}}</div>
            </el-form-item>
            <el-form-item label="量化等级：" prop="qualityLevel">
              <div class="w300">{{subjectData.qualityLevel ? subjectData.qualityLevel : '-'}}</div>
            </el-form-item>
            <el-form-item label="风险分级：" prop="riskLevel">
              <div class="w300">{{subjectData.riskLevel ? subjectData.riskLevel : '-'}}</div>
            </el-form-item>
            <el-form-item label="法人(负责人)：" prop="legalPerson">
             <div class="w300">{{subjectData.legalPerson ? subjectData.legalPerson : '-'}}</div>
            </el-form-item>
            <el-form-item label="联系电话：" prop="tel">
              <div class="w300">{{subjectData.tel ? subjectData.tel : '-'}}</div>
            </el-form-item>
            <el-form-item label="联系地址：" prop="address">
              <div class="w300">{{subjectData.address ? subjectData.address : '-'}}</div>
            </el-form-item>
             <el-form-item label="功能集：" prop="collection">
              <div class="w300">{{subjectData.collection ? subjectData.collection: '-'}}</div>
            </el-form-item>
            <el-form-item label="是否纳入餐饮示范街：" prop="demoStreetStr">
              <div class="w300">{{subjectData.demoStreetStr ? subjectData.demoStreetStr: '-'}}</div>
            </el-form-item>
          </div>
        </toggle-form>
          <toggle-form title="经营信息">
          <div class="item">
            <el-form-item label="经营面积：" prop="cover">
              <div class="w300">{{subjectData.cover ? subjectData.cover : '-'}}{{subjectData.cover?'㎡':''}}</div>
            </el-form-item>
            <el-form-item label="经营场所：" prop="workspace">
              <div class="w300">{{subjectData.workspace ? subjectData.workspace : '-'}}</div>
            </el-form-item>
            <el-form-item label="GPS地址：" prop="gpsAddress">
              <div class="w300">{{subjectData.gpsAddress ? subjectData.gpsAddress : '-'}}</div>
            </el-form-item>
            <div>
            <el-form-item label="经度：" prop="lng">
              <div class="w200">{{subjectData.lng ? subjectData.lng : '-'}}</div>
            </el-form-item>
            <el-form-item label="纬度：" prop="lat">
              <div class="w200">{{subjectData.lat ? subjectData.lat : '-'}}</div>
            </el-form-item>
            </div>
           <div>
             <el-form-item label="行业类型：" prop="buyerType">
              <div class="w200">{{subjectData.buyerType ? subjectData.buyerType : '-'}}</div>
            </el-form-item>
            <el-form-item label="学校类型：" prop="scType">
              <div class="w200">{{subjectData.scType ? subjectData.scType : '-'}}</div>
            </el-form-item>
           </div>
           <div>
             <el-form-item label="营业状态：" prop="workStatus">
              <div class="w200">{{subjectData.workStatus ? subjectData.workStatus : '-'}}</div>
            </el-form-item>
            <el-form-item label="从业人数：" prop="empNumber">
              <div class="w200">{{subjectData.empNumber ? subjectData.empNumber : '-'}}</div>
            </el-form-item>
           </div>
           <div>
             <el-form-item label="主体业态：" prop="entityType">
              <div class="w200">{{subjectData.entityType ? subjectData.entityType : '-'}}</div>
            </el-form-item>
            <el-form-item label="是否提供网络外卖服务：" prop="takeOut">
              <div class="w200">{{subjectData.takeOut ? subjectData.takeOut : '-'}}</div>
            </el-form-item>
           </div>
            <el-form-item label="网络经营：" prop="onlineType">
              <div class="w300">{{subjectData.onlineType ? subjectData.onlineType : '-'}}</div>
            </el-form-item>
          </div>
        </toggle-form>
        <toggle-form title="证照信息">
          <div class="item">
            <el-form-item label="食品经营许可证编号：" prop="licence">
              <div class="w300">{{subjectData.licence ? subjectData.licence : '-'}}</div>
            </el-form-item>
            <el-form-item label="食品经营许可证有效期：" prop="licenceExpdate">
              <div class="w300">{{subjectData.licenceExpdate ? subjectData.licenceExpdate : '-'}}</div>
            </el-form-item>
            <el-form-item label="食品经营许可证图片：" prop="licenceImgUrl">
              <div class="w500">
                <el-image :src="licenceImg" @click="preview(licenceImg, 'licenceImg')" fit="cover"></el-image>
                <div v-if="licenceDialogVisible" class="modal" @click.stop="licenceDialogVisible = false;">
                  <img :src="licenceImg" alt="" class="big-img">
                </div>
              </div>
            </el-form-item>
            <el-form-item label="营业执照编号：" prop="creditCode">
              <div class="w300">{{subjectData.creditCode ? subjectData.creditCode : '-'}}</div>
            </el-form-item>
            <el-form-item label="营业执照图片：" prop="creditImgUrl">
              <div class="w500">
                <el-image :src="creditImg" @click="preview(creditImg, 'creditImg')" fit="cover"></el-image>
                <div v-if="creditDialogVisible" class="modal" @click.stop="creditDialogVisible = false;">
                  <img :src="creditImg" alt="" class="big-img">
                </div>
              </div>
            </el-form-item>
          </div>
        </toggle-form>
      </el-form>
    </div>
    <div class="footer">
        <el-button @click="cancle" round>返回</el-button>
        <el-button type="primary" @click="toEdit('subjectData')" round>编辑</el-button>
    </div>
  </div>
</template>
<script>
import ToggleForm from "components/ToggleForm"
import ImgUpload from "components/ImgUpload"
import * as subManageApi from '@/api/subManage';
import * as mapping from '@/utils/enumList';
import * as moduleApi from '@/api/module'
export default {
  components: {
    ToggleForm,
    ImgUpload
  },
  data() {
    return {
      subjectData: {
        tobId: '',
        tobName: '',
        togId: '',
        togName: '',
        togSystemName: '',
        cameraInit: '',

        buyerName: '',
        areaId: '',
        isSyncTobAdminAccount: '',
        adminName: '',
        adminAccount: '',
        adminPassword: '',
        acquisitionMode: '1',
        traceabilityMode: '2',
        available: '1',
        buyerType: '',
        scType: '',
        qualityLevel: '',
        gpsAddress: '',
        lng: '',
        lat: '',
        legalPerson: '',
        tel: '',
        address: '',

        licence: '',
        licenceExpdate: '',
        licenceImgUrl: '',
        creditCode: '',
        creditImgUrl: '',

        deptCode: '',
        togLicense: '',
        togCreditCode: '',
        togEntityType: '',
      },
      dataRules: {},
      // platformType: '',
      // platformTypes: [{
      //   label: '望家欢',
      //   value: 'WJH'
      // }],
      // platformID: '',
      cameraInitValue: '',
      cameraInitTypes: [{
        label: '从TOB初始化',
        value: 'fromTOB'
      },{
        label: '从TOG初始化',
        value: 'fromTOG'
      }],
      echoFileId: '',
      getImgFile: '',
      imgnull: require('../../assets/images/imgnull.png'),
      licenceDialogVisible: false,
      creditDialogVisible: false,
      areaData: []
    }
  },
  computed: {
    creditImg: function() {
      if(this.subjectData.creditImgUrl) {
        return this.subjectData.creditImgUrl
      } else {
        return this.imgnull
      }
    },
    licenceImg: function() {
      if(this.subjectData.licenceImgUrl) {
        return this.subjectData.licenceImgUrl
      } else {
        return this.imgnull
      }
    },
  },
  methods: {
    // platformTypeChange() {
      
    // },
    cameraInitChange() {

    },
    preview(src, from) {
      if(src == this.imgnull) return
      if(from === 'creditImg') {
        this.creditDialogVisible = true
      } else {
        this.licenceDialogVisible = true
      }
    },
    cancle() {
      this.$router.go(-1)
    },
    toEdit() {
      this.$router.push({
          name: 'SubjectAdd',
          query: {
              type: 'edit',
              id: this.$route.query.id
          }
      })
    },
    async getModule(){
      let result  = await moduleApi.getFunctionList()
      console.log(result.data)
      return result.data
    }
  },
  mounted() {
    let id = this.$route.query.id
    subManageApi.subjectDetail({id: id}).then(async res => {
      if(res.code === 200) {
        // 详情数据回显
        res.data.isSyncTobAdminAccount =  mapping.keyToVal('isSyncTobAdminAccount', res.data.isSyncTobAdminAccount)
        res.data.acquisitionMode =  mapping.keyToVal('acquisitionMode', res.data.acquisitionMode)
        res.data.traceabilityMode =  mapping.keyToVal('traceabilityMode', res.data.traceabilityMode)
        res.data.available =  mapping.keyToVal('available', res.data.available)
        res.data.buyerType = mapping.keyToVal('buyerType', res.data.buyerType)
        res.data.scType = mapping.keyToVal('scType', res.data.scType)
        res.data.onlineType = mapping.keyToVal('onlineType',res.data.onlineType)
        res.data.takeOut = mapping.keyToVal('takeOut',res.data.takeOut)
        res.data.entityType = mapping.keyToVal('entityType',res.data.entityType)
        res.data.workStatus = mapping.keyToVal('workStatus',res.data.workStatus)
        let module = await this.getModule()
        module.forEach(item => {item.id === res.data.collectionId ? res.data.collection = item.name:''});
        this.subjectData = res.data 
      }
    }).catch(err => {})
  }
}
</script>
<style lang="scss" scoped>
  .tittle {
    text-align: left;
    font-size: 18px;
    font-weight: 500;
  }
  .content {
    text-align: left;
    .el-form {
      padding: 0 calc((100% - 1200px) / 2);
    }
    .item {
      margin-top: 40px; 
    }
    .el-image {
      width: 200px;
      height: 200px;
      border-radius: 4px;
      cursor: point;
    }
    .modal {
      position: fixed;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      z-index: 990;
      display: flex;
      justify-content: center;
      align-items: center;
      .big-img {
        max-width: 800px;
      }
    }
  }
  .footer {
    text-align: right;
  }
</style>
